// Import Swiper React components
import { Swiper } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Autoplay } from 'swiper/modules';
// style
import style from './Slider.module.css';

const Slider = ({ children, loop, navigation, autoplay }) => {
  return (
    <div className={style.slide}>
      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          680: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          860: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1060: {
            slidesPerView: 3.2,
            spaceBetween: 30,
          },
          1490: {
            slidesPerView: 4.2,
            spaceBetween: 30,
          },
        }}
        navigation={navigation}
        pagination={{
          clickable: true,
        }}
        autoplay={
          autoplay && {
            delay: 6000,
            disableOnInteraction: false,
          }
        }
        loop={loop}
        modules={[Navigation, Autoplay]}
        className="mySwiper"
      >
        {children}
      </Swiper>
    </div>
  );
};
export default Slider;
